import { useContext } from "react";
import { IPageContext, PageContext } from "./base-page-layout";

function  usePage(): IPageContext {
    const context = useContext(PageContext);

    /** check if the component is inside <BasePageLayout ...> component */
    if (!context?.setTitle) {
        console.info('Missing BasePageLayout component above usePage hook');
    }

    return context;
}

export default usePage; 
